<!--
    file type .....: HTML file: paste-selector.component.html
    Created By ....: ianday
    Date ..........: 4/21/25 
-->
<div class="paste-selector-container" id="pasteControl" (keydown)="onKeyDown($event)" (paste)="onPasteHandler($event)"
     contenteditable>
</div>
  <!--  <img src="{{this.url}}"  style="width:350px; height:200px; overflow:scroll;" /> -->
